"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getRootFontSize(dynamic) {
    if (dynamic === void 0) { dynamic = false; }
    return parseFloat((dynamic &&
        typeof getComputedStyle !== 'undefined' &&
        getComputedStyle(document.documentElement).fontSize) ||
        '16');
}
// convert rems to px using document font size
function convertRemToPx(rem, dynamic) {
    if (dynamic === void 0) { dynamic = false; }
    return rem * getRootFontSize(dynamic) + "px";
}
exports.convertRemToPx = convertRemToPx;
function convertRemStrToPx(remStr, dynamic) {
    if (dynamic === void 0) { dynamic = false; }
    return convertRemToPx(parseFloat(remStr), dynamic);
}
exports.convertRemStrToPx = convertRemStrToPx;
// convert px to rems using document font size
function convertPixelsToRem(px, dynamic) {
    if (dynamic === void 0) { dynamic = false; }
    return px / getRootFontSize(dynamic) + "rem";
}
exports.convertPixelsToRem = convertPixelsToRem;
function convertPixelsStrToRem(pxStr, dynamic) {
    if (dynamic === void 0) { dynamic = false; }
    return convertPixelsToRem(parseFloat(pxStr), dynamic);
}
exports.convertPixelsStrToRem = convertPixelsStrToRem;
function dictionaryToArray(dict) {
    return Object.keys(dict).map(function (key) { return dict[key]; });
}
exports.dictionaryToArray = dictionaryToArray;
function strIncludes(filter, value) {
    return value.toLowerCase().includes(filter.toLowerCase());
}
exports.strIncludes = strIncludes;
//# sourceMappingURL=base.js.map